import { notification } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { useState } from 'react';
import { useUpdateEducationClassMutation, type EducationClass } from 'shared/api';
import type { EducationClassFormValues } from 'entities/education-class/form';

export const useEditEducationClass = (selectedEducationClass: EducationClass) => {
  const [form] = useForm<EducationClassFormValues>();
  const [updateEducationClass, { isLoading }] = useUpdateEducationClassMutation();
  const [visible, setVisible] = useState(false);

  const onSubmit = () => {
    form.validateFields().then((values) => {
      updateEducationClass({
        id: selectedEducationClass!.id,
        ...values,
        includeSaturday: values.includeSaturday ?? false,
        saturdayMorningShift: values.saturdayMorningShift ?? false,
      })
        .then(() => {
          hideModal();
        })
        .catch((error) => {
          notification.error({ message: 'Не удалось обновить класс' });
          throw error;
        });
    });
  };

  const showModal = () => {
    if (selectedEducationClass) {
      form.setFieldsValue({ ...selectedEducationClass });
    }
    setVisible(true);
  };

  const hideModal = () => {
    setVisible(false);
    form.resetFields();
  };

  return {
    state: {
      form,
      visible,
      isLoading,
    },
    methods: {
      onSubmit,
      showModal,
      hideModal,
    },
  };
};
